module.exports = __webpack_public_path__ + "static/media/SuisseIntlMono-Regular.e05cf9ac.woff2";